export const LOCALES = ['id', 'en'] as const

export type Locale = (typeof LOCALES)[number]

export const DEFAULT_LOCALE: Locale = 'id'

/** A content field that exists in both languages. */
export type Localized<T = string> = Record<Locale, T>

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as readonly string[]).includes(value)
}

/**
 * Widens a literal-typed dictionary (`as const`) to plain strings, so that a
 * translation file has to match the *shape* of the source locale, not its
 * exact wording.
 */
export type DeepWiden<T> = T extends string
  ? string
  : { [K in keyof T]: DeepWiden<T[K]> }
